import React, { useState, useEffect, useContext } from "react";

import StaffTable from "components/staff/StaffTable";
import AdminServices from "services/AdminServices";
import useToggleDrawer from "hooks/useToggleDrawer";
import PageTitle from "components/Typography/PageTitle";
import MainDrawer from "components/drawer/MainDrawer";
import StaffDrawer from "components/drawer/StaffDrawer";
import { SidebarContext } from "context/SidebarContext";

import TableLoading from "components/preloader/TableLoading";
import Somethingwentwrong from "pages/Somethingwentwrong";

import DeleteModal from "components/modal/DeleteModal";
import useAsync from "hooks/useAsync";

import {
  Card,
  CardBody,
  Input,
  Table,
  TableCell,
  TableContainer,
  TableHeader,
  Button,
} from "@windmill/react-ui";
import { FiPlus } from "react-icons/fi";
import sidebar from "routes/sidebar";
import NotFound from "components/table/NotFound";

import ExportData from "components/common/ExportData";
import socket from "services/SocketService";
// const adminInfo = Cookies.get("adminInfo")
//   ? JSON.parse(Cookies.get("adminInfo"))
//   : null;



const style = `.downloadbtn .svg-inline--fa {
  font-size: 30px; 
  color: grey;
  padding: 9px 10px;
  margin: unset;
}`;

const Employee = () => {
  const adminInfo = localStorage.getItem("adminInfo")
  ? JSON.parse(localStorage.getItem("adminInfo"))
  : null;
  const { toggleDrawer } = useContext(SidebarContext);
  const [searchText, setSearchText] = useState("");
  const { data, loading } = useAsync(() => AdminServices.getAllStaff());

  const [status, setStatus] = useState("");
  const [liveStaff, setLiveStaff] = useState([]);
  const isDataArray = Array.isArray(data?.data);
  const safeData = liveStaff;
  const isAdmin = adminInfo?.id === 1;

  // Keep a mutable copy of the fetched list so the live roster broadcast
  // below can patch is_online without refetching the whole page.
  useEffect(() => {
    setLiveStaff(isDataArray ? data.data : []);
    // eslint-disable-next-line
  }, [data]);

  // Live online/offline status — the socket server pushes a fresh roster
  // whenever any employee registers/goes offline (see broadcastAvailableEmployees
  // in b2bcabs_socket/server.js).
  useEffect(() => {
    const handleRosterUpdate = ({ employees: roster }) => {
      if (!Array.isArray(roster)) return;
      const onlineById = new Map(roster.map((r) => [Number(r.id), r.is_online]));
      setLiveStaff((prev) =>
        prev.map((row) =>
          onlineById.has(Number(row.id))
            ? { ...row, is_online: onlineById.get(Number(row.id)) }
            : row
        )
      );
    };

    socket.on("employee_roster_update", handleRosterUpdate);
    return () => socket.off("employee_roster_update", handleRosterUpdate);
  }, []);

  const hideView = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "staff" && perm.view === 1
      );

  const hideDelete = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "staff" && perm.delete === 1
      );

  const hideEdit = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "staff" && perm.edit === 1
      );

  const hideAdd = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "staff" && perm.add === 1
      );

  const hideExport = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "staff" && perm.export === 1
      );

  useEffect(() => {
    if (data?.status) {
      setStatus(data.status);
    } else {
      setStatus(false);
    }
  }, [data?.status]);

  const { title, serviceId } = useToggleDrawer();

  const csvData = [
    ["First Name", "Last Name", "Email", "Contact", "Staff", "Status"],
    ...(safeData || []).map(
      ({ emp_image, firstname, lastname, email, mobile, role, status }) => [
        firstname,
        lastname,
        email,
        mobile,
        role,
        status,
      ]
    ),
  ];


  const filteredData =
    safeData?.filter(
      (item) =>
        (item.firstname &&
          item.firstname.toLowerCase().includes(searchText.toLowerCase())) ||
        (item.lastname &&
          item.lastname.toLowerCase().includes(searchText.toLowerCase())) ||
        (item.email &&
          item.email.toLowerCase().includes(searchText.toLowerCase())) ||
        (item.mobile &&
          item.mobile.toString().includes(searchText.toString())) ||
        (item.staff &&
          item.staff.toLowerCase().includes(searchText.toLowerCase()))
    ) || [];

    
    
  return (
    <>
      {hideView && (
        <>
          <DeleteModal id={serviceId} title={title} />

          <style>{style}</style>
          <PageTitle sidebar={sidebar().sidebar} />

          <MainDrawer>
            <StaffDrawer id={serviceId} />
          </MainDrawer>

          <Card className="min-w-0 shadow-xs overflow-hidden bg-white !dark:bg-gray-800 mb-5">
            <CardBody>
              <form className="items-center gap-6 flex">
                <div className="flex-1">
                  <Input
                    className="border h-10 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
                    type="search"
                    name="search"
                    autoComplete="off"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    placeholder="Search"
                  />
                </div>

                {hideAdd && (
                  <Button
                    onClick={toggleDrawer}
                    className="w-56 rounded-md h-10"
                  >
                    <span className="mr-3">
                      <FiPlus />
                    </span>
                    Add User
                  </Button>
                )}

                {hideExport && (
                  <ExportData
                    title="Staff"
                    exportData={csvData}
                    filename="Employee List.csv"
                  />
                )}
              </form>
            </CardBody>
          </Card>

          <div className="data-table-container">
            {loading ? (
              // Display a loading spinner or message while data is being fetched
              <TableLoading row={12} col={6} width={190} height={20} />
            ) : status === false || status === undefined ? (
              <Somethingwentwrong title="Something went wrong, please try again later." />
            ) : safeData.length > 0 ? (
              <TableContainer
                className="mb-8"
                style={{
                  maxHeight: "65vh",
                  overflowY: "scroll",
                  scrollbarWidth: "thin",
                }}
              >
                <Table>
                  <TableHeader className="custom-table-header capitalize sticky top-0 z-10">
                    <tr>
                      <TableCell className="text-center">Sl.No.</TableCell>
                      <TableCell className="text-center">Name</TableCell>
                      <TableCell className="text-center">Email</TableCell>
                      <TableCell className="text-center">Role</TableCell>
                      <TableCell className="text-center">Status</TableCell>
                      <TableCell className="text-center">Online</TableCell>
                      <TableCell className="text-center">Actions</TableCell>
                    </tr>
                  </TableHeader>

                  <StaffTable
                    staffdata={filteredData}
                    hideEdit={hideEdit}
                    hideDelete={hideDelete}
                  />
                </Table>
              </TableContainer>
            ) : (
              // Show NotFound if there is no data
              <NotFound title="There are no Staffs." />
            )}
          </div>
        </>
      )}
    </>
  );
};

export default Employee;
